/**
 * Voucher Service for handling voucher operations
 * 
 * SECURITY UPDATE: April 2025
 * All direct references to backend URLs have been replaced with secure server proxies
 * to prevent exposing sensitive backend URLs in client-side code.
 */
export const useVoucherService = () => {
  /**
   * Check voucher for MSN
   * Uses secure server proxy endpoint instead of direct backend URL
   */
  const voucherMsn = async (msnNumber: string): Promise<any | null> => {
    try {
      const response: any = await $fetch(
        `/api/integration/voucher-msn`,
        {
          method: "POST",
          credentials: "include",
          body: { msnNumber },
        }
      );

      return response?.result || null;
    } catch (error) {
      // Security: Error handling without logging for security (2025-05-05)
      throw error;
    }
  };
  /**
   * Check voucher for MSN and SIM
   * Uses secure server proxy endpoint instead of direct backend URL
   */
  const voucherMsnSim = async (
    msnNumber: string,
    voucherNumber: string
  ): Promise<any | null> => {
    try {
      const response: any = await $fetch(
        `/api/integration/voucher-msn-sim`,
        {
          method: "POST",
          credentials: "include",
          body: { msnNumber, voucherNumber },
        }
      );

      return response?.result || null;
    } catch (error) {
      // Security: Error handling without logging for security (2025-05-05)
      throw error;
    }
  };
  /**
   * Redeem a voucher
   * Uses secure server proxy endpoint instead of direct backend URL
   */
  const voucherRedeem = async (payload: object): Promise<any | null> => {
    try {
      const response: any = await $fetch(
        `/api/integration/voucher-redeem`,
        {
          method: "POST",
          body: payload,
          credentials: "include",
        }
      );

      return response?.result || null;
    } catch (error) {
      // Security: Error handling without logging for security (2025-05-05)
      throw error;
    }
  };

  return {
    voucherMsn,
    voucherMsnSim,
    voucherRedeem,
  };
};
